import * as Sentry from '@sentry/react';
import type { LoggingService } from '@repo/core';

/**
 * Logging service that writes to console + Sentry.
 * In production, only warnings and errors reach Sentry.
 */
export class SentryLoggingService implements LoggingService {
  info(message: string, context?: Record<string, unknown>) {
    console.info(`[INFO] ${message}`, context);
  }

  warn(message: string, context?: Record<string, unknown>) {
    console.warn(`[WARN] ${message}`, context);
    Sentry.addBreadcrumb({ message, data: context, level: 'warning' });
  }

  error(message: string, error?: Error, context?: Record<string, unknown>) {
    console.error(`[ERROR] ${message}`, error, context);
    Sentry.captureException(error ?? new Error(message), {
      extra: { message, ...context },
    });
  }
}
